import { RequestCreateLeadPaymentLink } from '@/api/types/crm/crm.types'
import { DEFAULT_MONTHLY_COURSE_PERIOD_UNIT } from './components/MonthlyCourseLinkFields/monthlyCourseLink.utils'

export type CreateLinkFieldType = Omit<
  RequestCreateLeadPaymentLink,
  'lead_funnel_id'
>

export const CREATE_LINK_INITIAL_VALUES = {
  type: 'course',
  course_id: null,
  tariff_id: null,
  class_id: null,
  group_id: null,
  price: null,
  first_price: null,
  lesson_duration: null,
  teacher_id: null,
  salary_per_hour: null,
  discount: null,
  discount_mode: null,
  apply_discount_each_payment: false,
  enroll_date: null,
  is_promo_enabled: true,
  value: null,
  is_value_fixed: false,
  period_unit: DEFAULT_MONTHLY_COURSE_PERIOD_UNIT,
  is_show_hidden_tariffs: true,
} as const
